import * as React from 'react';
import { styled } from '@glitz/react';
import { ButtonBlock } from 'webapp/blocks/ButtonBlock';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';

type Props = {
  buttons: NordicNest.Api.Button[];
};

export function ButtonBlockGroup({ buttons }: Props) {
  return (
    <Wrapper>
      <Buttons>
        {buttons?.map((button, i) => (
          <ButtonBlock key={i} {...button} />
        ))}
      </Buttons>
    </Wrapper>
  );
}

const Wrapper = styled.span({
  display: 'inline-block',
});

const Buttons = styled.span(
  createMaxSmallViewportDecorator({
    flexDirection: 'column',
  }),
  {
    display: 'flex',
    flexDirection: 'row',
    columnGap: t => t.spacing.m,
    rowGap: t => t.spacing.m,
    alignItems: 'center',
    justifyContent: 'center',
  },
);
